import TerminalIcon from '@mui/icons-material/Terminal';
import {Box, Typography} from '@mui/material';
import {PgHistoryAgentEvent} from '_logics/LFCSourceUtil';

type AgentToolEvent = Extract<PgHistoryAgentEvent, {type: 'tool'}>;

type Props = {
  events: AgentToolEvent[];
};

const AgentToolLog = ({events}: Props) => {
  if (events.length === 0) return null;

  return (
    <Box sx={{borderTop: 1, borderColor: 'divider', px: 2, py: 1}}>
      {events.map((event, index) => (
        <Box key={`${event.label}-${index}`} sx={{display: 'flex', gap: 1, py: 0.5}}>
          <TerminalIcon fontSize="small" color="action" />
          <Box sx={{minWidth: 0}}>
            <Typography variant="caption" color="text.secondary" sx={{wordBreak: 'break-all'}}>
              {event.label}
            </Typography>
            {event.command && (
              <Typography
                component="pre"
                variant="caption"
                color="text.secondary"
                sx={{m: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontFamily: 'monospace'}}
              >
                {event.command}
              </Typography>
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AgentToolLog;
